'use es6';

import { combineEpics } from 'redux-observable';
import archive from './archive';
import archiveAndUnpublish from './archiveAndUnpublish';
import attachToLanguageMaster from './attachToLanguageMaster';
import removeFromLanguageGroup from './removeFromLanguageGroup';
import changeAudienceAccess from './changeAudienceAccess';
import checkForSmartContentData from './checkForSmartContentData';
import chooseVariationWinner from './chooseVariationWinner';
import clone from './clone';
import convert from './convert';
import createAndUseInList from './createAndUseInList';
import createTranslationVariation from './createTranslationVariation';
import createVariation from './createVariation';
import deleteEpic from './delete';
import fetchAllLists from './fetchAllLists';
import fetchDomain from './fetchDomain';
import fetchListRegistrations from './fetchListRegistrations';
import fetchSpecificLists from './fetchSpecificLists';
import fetchStaticLists from './fetchStaticLists';
import fetchSettings from './fetchSettings';
import fetchVideos from './fetchVideos';
import finishOnboardingTour from './finishOnboardingTour';
import getMabEndTest from './mabEndTest';
import getMabPastExperiments from './mabPastExperiments';
import initializeHeaderDetailsSidebar from './initializeHeaderDetailsSidebar';
import navigatedToExternalPage from './navigatedToExternalPage';
import navigatedToPage from './navigatedToPage';
import publish from './publish';
import rerunVariation from './rerunVariation';
import unarchive from './unarchive';
import unpublish from './unpublish';
import updateContentTitle from './updateContentTitle';
import useInList from './useInList';
import ads from './ads';
export default combineEpics(ads, archive, archiveAndUnpublish, attachToLanguageMaster, changeAudienceAccess, checkForSmartContentData, chooseVariationWinner, clone, convert, createAndUseInList, createTranslationVariation, createVariation, deleteEpic, fetchAllLists, fetchDomain, fetchListRegistrations, fetchSpecificLists, fetchStaticLists, fetchSettings, fetchVideos, finishOnboardingTour, getMabEndTest, getMabPastExperiments, initializeHeaderDetailsSidebar, navigatedToExternalPage, navigatedToPage, publish, removeFromLanguageGroup, rerunVariation, unarchive, unpublish, updateContentTitle, useInList);